import { useState } from 'react';
import { getCoinBalance as requestCoinBalance } from '../../../apis';

export const useCoinBalance = () => {
    const [coinCount, setCoinCount] = useState<number>(0);
    const [smsPackCount, setSmsPackCount] = useState<number>(0);

    /**
     * 获取云币和短信数量
     */
    const getCoinBalance = () => {
        return requestCoinBalance().then((coinBalance) => {
            setCoinCount(coinBalance.balance);
            setSmsPackCount(coinBalance.available.sms ?? 0);
        });
    };

    return { coinCount, smsPackCount, getCoinBalance };
};

export default useCoinBalance;
